import { render, staticRenderFns } from "./DiscountAtEndTemplate.vue?vue&type=template&id=45e8393e&scoped=true&"
import script from "./DiscountAtEndTemplate.vue?vue&type=script&lang=js&"
export * from "./DiscountAtEndTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8393e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e8393e')) {
      api.createRecord('45e8393e', component.options)
    } else {
      api.reload('45e8393e', component.options)
    }
    module.hot.accept("./DiscountAtEndTemplate.vue?vue&type=template&id=45e8393e&scoped=true&", function () {
      api.rerender('45e8393e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/DiscountAtEndTemplate.vue"
export default component.exports